var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMistral = function SvgMistral(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 176 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFCD00",
    stroke: "#636363",
    strokeOpacity: 0.2,
    strokeWidth: 0.5,
    d: "M15 1h32v32H15zM143 1h32v32h-32z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA400",
    stroke: "#636363",
    strokeOpacity: 0.2,
    strokeWidth: 0.5,
    d: "M15 33h32v32H15zM47 33h32v32H47zM111 33h32v32h-32zM143 33h32v32h-32z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF7100",
    stroke: "#636363",
    strokeOpacity: 0.2,
    strokeWidth: 0.5,
    d: "M15 65h32v32H15zM47 65h32v32H47zM79 65h32v32H79zM111 65h32v32h-32zM143 65h32v32h-32z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF4902",
    stroke: "#636363",
    strokeOpacity: 0.2,
    strokeWidth: 0.5,
    d: "M15 97h32v32H15zM79 97h32v32H79zM143 97h32v32h-32z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF0006",
    stroke: "#636363",
    strokeOpacity: 0.2,
    strokeWidth: 0.5,
    d: "M15 129h32v32H15zM143 129h32v32h-32z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M0 1h16v160H0zM63 97h16v32H63zM95 33h16v32H95zM127 1h16v32h-16zM127 97h16v64h-16z"
  })));
};
export default SvgMistral;